import { Reveal, SectionHeader } from "@/components/Reveal";
import { einsatzchronik } from "@/data/content";

const Bar = ({ label, brand, thl }) => (
  <div>
    <p className="font-technical uppercase tracking-wider text-fw-gold text-sm mb-2">{label}</p>
    <div className="flex h-4 w-full overflow-hidden rounded-full bg-white/10">
      <div className="bg-fw-red" style={{ width: `${brand}%` }} title={`Brand ${brand}%`} />
      <div className="bg-fw-blue" style={{ width: `${thl}%` }} title={`Technische Hilfe ${thl}%`} />
    </div>
    <div className="mt-2 flex justify-between font-body text-xs text-white/60">
      <span>Brand {brand}%</span>
      <span>Techn. Hilfe {thl}%</span>
    </div>
  </div>
);

const Einsatzchronik = () => (
  <section id="einsatzchronik" className="grain relative bg-fw-charcoal py-24 md:py-32 text-white" data-testid="einsatzchronik-section">
    <div className="mx-auto max-w-7xl px-5 md:px-8">
      <SectionHeader kicker="Einsätze" title={einsatzchronik.title} subtitle={einsatzchronik.subtitle} dark testId="einsatzchronik-header" />

      <div className="grid gap-8 lg:grid-cols-12">
        {/* Bento Bildraster */}
        <div className="lg:col-span-7 grid grid-cols-2 gap-3">
          {einsatzchronik.images.map((src, i) => (
            <Reveal
              key={i}
              delay={i * 0.08}
              className={`overflow-hidden ${i === 0 ? "col-span-2 aspect-[16/9]" : "aspect-square"}`}
            >
              <img src={src} alt="Einsatz" className="h-full w-full object-cover transition-transform duration-700 hover:scale-105" />
            </Reveal>
          ))}
        </div>

        {/* Vergleich + Chronik */}
        <div className="lg:col-span-5 space-y-8">
          <Reveal>
            <p className="font-body text-white/70">{einsatzchronik.intro}</p>
          </Reveal>
          <Reveal delay={0.1} className="space-y-6 border border-white/10 bg-white/5 p-6">
            {einsatzchronik.vergleich.map((v) => (
              <Bar key={v.jahr} label={v.jahr} brand={v.brand} thl={v.thl} />
            ))}
            <div className="grid grid-cols-2 gap-4 pt-4 border-t border-white/10">
              {einsatzchronik.vergleich.map((v) => (
                <div key={v.jahr}>
                  <p className="font-technical text-fw-gold text-sm">{v.jahr}</p>
                  <p className="font-body text-white text-sm">{v.einsaetze} Einsätze · {v.stunden} Std.</p>
                </div>
              ))}
            </div>
          </Reveal>

          <Reveal delay={0.15}>
            <ul className="space-y-3">
              {einsatzchronik.ereignisse.map((e) => (
                <li key={e.jahr} className="flex gap-4 border-l-2 border-fw-red pl-4">
                  <span className="font-technical font-bold text-fw-gold w-14 shrink-0">{e.jahr}</span>
                  <span className="font-body text-white/70 text-sm">{e.text}</span>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default Einsatzchronik;
